/**
 * マッチング設定一覧ページ コンテナ
 */
import type React from "react";
import { useCallback } from "react";
import {
  useActivateMatchingSetting,
  useDeactivateMatchingSetting,
  useDeleteMatchingSetting,
  useMatchingSettings,
} from "../../../hooks/use-matching-settings-api";
import { MatchingSettingsPage } from "./MatchingSettingsPage";

const MatchingSettingsPageContainer: React.FC = () => {
  const { settings, loading, error, refetch } = useMatchingSettings();
  const { activateSetting, loading: isActivating } =
    useActivateMatchingSetting();
  const { deactivateSetting, loading: isDeactivating } =
    useDeactivateMatchingSetting();
  const { deleteSetting, loading: isDeleting } = useDeleteMatchingSetting();

  const handleActivate = useCallback(
    async (settingId: string) => {
      await activateSetting(settingId);
      await refetch();
    },
    [activateSetting, refetch],
  );

  const handleDeactivate = useCallback(
    async (settingId: string) => {
      await deactivateSetting(settingId);
      await refetch();
    },
    [deactivateSetting, refetch],
  );

  const handleDelete = useCallback(
    async (settingId: string) => {
      await deleteSetting(settingId);
      await refetch();
    },
    [deleteSetting, refetch],
  );

  return (
    <MatchingSettingsPage
      settings={settings}
      loading={loading}
      error={error ? { message: error.message } : null}
      onActivate={handleActivate}
      onDeactivate={handleDeactivate}
      onDelete={handleDelete}
      isActivating={isActivating || isDeactivating}
      isDeleting={isDeleting}
    />
  );
};

export default MatchingSettingsPageContainer;
